import {onFind} from "@elements/init-modules-in-scope";
import {findIn} from "@elements/dom-utils";
import Popover from 'bootstrap/js/dist/popover';

export function init() {
    onFind('.js-wtp-info', function (baseElement) {

        const button = findIn('.js-wtp-info__button', baseElement);
        const content = findIn('.js-wtp-info__content', baseElement);

        if (button && content) {
            const options = {
                html: true,
                content: content.innerHTML,
                placement: 'top',
                template: '<div class="popover wtp-info__popover" role="tooltip"><div class="popover-arrow"></div><div class="popover-body"></div></div>'
            }

            let popover = Popover.getOrCreateInstance(button, options);
        }
    });
}